import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ButtonGroup } from '@/components/ui/Button/ButtonGroup';
export const ModalFooterAction = (props) => {
    const { children, className = '', isInline = false, space } = props;
    return (_jsx(ButtonGroup, Object.assign({ className: clsx('justify-center', 'mt-28 mx-auto', className), isInline: isInline, space: space }, { children: children })));
};
